// src/pages/income/env/total/AircondDetailPanel.jsx
// ✅ 환경/종합 "냉난방기 종합세척" 수입 전용 상세내역 입력 — env_total.AircondCleaningDetail
// (구분/대수/단가/계약금액)에 대응. _shared/GenericDetailTablePanel(자유텍스트 열 범용
// 패널)은 구분 select(4종)와 계약금액 자동계산(대수×단가)을 지원하지 않아 이 사업
// 전용 패널을 새로 만들었다. IncomeDraftNew.jsx가 config.DetailPanel로 주입받아
// config.detailPanelCategories에 속한 종류를 골랐을 때만 렌더한다.
import React, { useState } from "react";

const TYPE_OPTIONS = [
  { value: "wall", label: "벽걸이형" },
  { value: "stand", label: "스탠드형" },
  { value: "oneway", label: "1way형" },
  { value: "twoway", label: "2way형" },
];

const comma = (n) => (n ? Number(n).toLocaleString() : "0");

function emptyRow() {
  return { type: "wall", quantity: "", unitPrice: "" };
}

export default function AircondDetailPanel({ onRowsChange }) {
  const [rows, setRows] = useState([]);
  const [form, setForm] = useState(emptyRow());

  const notify = (next) => {
    setRows(next);
    onRowsChange(
      next.map((r) => ({
        aircond_type: r.type,
        quantity: Number(r.quantity) || 0,
        unit_price: Number(r.unitPrice) || 0,
        contract_amount: (Number(r.quantity) || 0) * (Number(r.unitPrice) || 0),
      }))
    );
  };

  const addRow = () => {
    const qty = Number(form.quantity);
    const price = Number(form.unitPrice);
    if (!qty || qty <= 0) return alert("대수를 입력하세요");
    if (!price || price <= 0) return alert("단가를 입력하세요");
    notify([...rows, { ...form }]);
    setForm(emptyRow());
  };

  const removeRow = (idx) => {
    notify(rows.filter((_, i) => i !== idx));
  };

  const cellStyle = { border: "1px solid #d1d5db", padding: "6px 8px", fontSize: 13 };
  const inputStyle = { width: "100%", border: "none", fontSize: 13, textAlign: "center", outline: "none" };

  return (
    <div style={{ background: "#fff", border: "1px solid #ddd", borderRadius: 8, padding: 16, marginBottom: 16 }}>
      <strong>냉난방기 종합세척 상세내역</strong>
      <table style={{ width: "100%", borderCollapse: "collapse", marginTop: 8 }}>
        <thead>
          <tr style={{ background: "#f9fafb" }}>
            <th style={cellStyle}>구분</th>
            <th style={cellStyle}>대수</th>
            <th style={cellStyle}>단가</th>
            <th style={cellStyle}>계약금액(자동)</th>
            <th style={cellStyle}></th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={cellStyle}>
              <select value={form.type} onChange={(e) => setForm((f) => ({ ...f, type: e.target.value }))} style={inputStyle}>
                {TYPE_OPTIONS.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
              </select>
            </td>
            <td style={cellStyle}>
              <input value={form.quantity} onChange={(e) => setForm((f) => ({ ...f, quantity: e.target.value.replace(/[^\d]/g, "") }))} style={inputStyle} />
            </td>
            <td style={cellStyle}>
              <input value={form.unitPrice} onChange={(e) => setForm((f) => ({ ...f, unitPrice: e.target.value.replace(/[^\d]/g, "") }))} style={inputStyle} />
            </td>
            <td style={{ ...cellStyle, textAlign: "right" }}>{comma((Number(form.quantity) || 0) * (Number(form.unitPrice) || 0))}</td>
            <td style={cellStyle}><button type="button" onClick={addRow}>추가</button></td>
          </tr>
          {rows.map((r, idx) => (
            <tr key={idx}>
              <td style={cellStyle}>{TYPE_OPTIONS.find((t) => t.value === r.type)?.label}</td>
              <td style={{ ...cellStyle, textAlign: "center" }}>{comma(r.quantity)}</td>
              <td style={{ ...cellStyle, textAlign: "right" }}>{comma(r.unitPrice)}</td>
              <td style={{ ...cellStyle, textAlign: "right" }}>{comma((Number(r.quantity) || 0) * (Number(r.unitPrice) || 0))}</td>
              <td style={cellStyle}><button type="button" onClick={() => removeRow(idx)}>삭제</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
